//@flow
import React from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import getter from 'dibs-object-getter';

import { Button } from 'dibs-elements/exports/Button';

import { profileStatuses } from '../../constants';

import styles from './ProfileShowcase.scss';

import type { ProfileShowcase_tradeFirm as TradeFirmType } from './__generated__/ProfileShowcase_tradeFirm.graphql';
import type { ProfileShowcase_viewer as Viewer } from './__generated__/ProfileShowcase_tradeFirm.graphql';

type Props = {|
    tradeFirm?: TradeFirmType,
    viewer?: Viewer,
|};

function ProfileShowcaseComponent(props: Props) {
    if (getter(props.tradeFirm).value('profileStatus') === profileStatuses.ACTIVE) {
        return null;
    }

    const placementsGetter = getter(props)
        .at('tradeFirm')
        .at('rewards')
        .at('profileAwarenessPlacements');
    const title = placementsGetter.value('moduleTitle');
    const cta = placementsGetter.value('ctaCopy');
    const body = placementsGetter.value('bodyCopy');
    const iconUri = getter(props.viewer)
        .at('tradeProgramsQuery')
        .at(0)
        .value('iconUri');
    const urlLabel = getter(props.tradeFirm)
        .at('publicProfile')
        .value('urlLabel');

    return (
        <div className={styles.wrapper}>
            {iconUri && <img src={iconUri} className={styles.icon} />}
            <div className={styles.contentSection}>
                {title && <div className={styles.title}>{title}</div>}
                {body && <div>{body}</div>}
            </div>
            {cta && urlLabel && (
                <div className={styles.buttonWrapper}>
                    <Button
                        dataTn="complete-profile"
                        href={`/design-firms/${urlLabel}/edit/`}
                        size="small"
                        fullWidth
                    >
                        {cta}
                    </Button>
                </div>
            )}
        </div>
    );
}

export const ProfileShowcase = createFragmentContainer(ProfileShowcaseComponent, {
    tradeFirm: graphql`
        fragment ProfileShowcase_tradeFirm on TradeFirmType {
            profileStatus
            publicProfile {
                urlLabel
            }
            rewards {
                profileAwarenessPlacements {
                    moduleTitle
                    ctaCopy
                    bodyCopy
                }
            }
        }
    `,
    viewer: graphql`
        fragment ProfileShowcase_viewer on Viewer {
            tradeProgramsQuery(programCodes: ["PUBLIC_PROFILE_PUBLISH"]) {
                iconUri
            }
        }
    `,
});
